(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function formatMoney(cents) {
    return Shopify.formatMoney(cents, window.gbBundleText.moneyFormat);
  }
  function inWindow(element) {
    var now = Math.floor(Date.now() / 1000);
    var start = Number(element.dataset.gbStart || 0), end = Number(element.dataset.gbEnd || 0);
    return start <= now && (!end || now < end);
  }
  function refreshPage(page) {
    var rows = Array.from(page.querySelectorAll('[data-gb-item]')).sort(function (a, b) { return Number(a.dataset.gbIndex) - Number(b.dataset.gbIndex); });
    var available = page.dataset.gbLive === 'true' && inWindow(page), msrp = 0;
    var ids = rows.map(function (row) {
      var picker = row.querySelector('[data-gb-variant-picker]');
      var option = picker && picker.selectedOptions[0];
      var price = Number(option ? option.dataset.price : row.dataset.gbValue);
      msrp += price;
      if (option && option.dataset.available !== 'true') available = false;
      var value = row.querySelector('[data-gb-item-value]');
      if (value) value.innerHTML = formatMoney(price);
      var itemPrice = row.querySelector('[data-gb-item-price]');
      if (value && itemPrice) value.hidden = price <= Number(itemPrice.dataset.gbItemPrice);
      return option ? option.value : row.dataset.gbVariant;
    });
    if (!rows.length) msrp = Number(page.dataset.gbDefaultMsrp || 0);
    var price = Number(page.dataset.gbPrice);
    if (msrp <= price) available = false;
    var form = page.querySelector('[data-gb-bundle-form]');
    if (form) {
      if (rows.length) form.elements['properties[_gb_bundle_variants]'].value = ids.join(',');
      var button = form.querySelector('button[type="submit"]');
      button.disabled = !available || button.dataset.gbBusy === 'true';
      button.querySelector('[data-add-to-cart-text]').textContent = available ? page.dataset.gbAddText : page.dataset.gbSoldText;
    }
    var stock = page.querySelector('[data-gb-stock]');
    if (stock) {
      var stockText = stock.querySelector('[data-gb-stock-text]');
      var circle = stock.querySelector('.npStockCircle');
      if (stockText) stockText.textContent = available ? stock.dataset.gbInStockText : stock.dataset.gbOutText;
      else stock.textContent = available ? window.gbBundleText.inStock : window.gbBundleText.unavailable;
      if (circle) circle.setAttribute('fill', available ? '#22C55E' : '#ad1d1d');
    }
    var compare = page.querySelector('[data-gb-msrp]');
    if (compare) { compare.innerHTML = formatMoney(msrp); compare.hidden = msrp <= price; }
    var badge = page.querySelector('[data-gb-badge]');
    if (badge) {
      badge.hidden = msrp <= price;
      badge.textContent = msrp > price ? badge.dataset.gbSaveTemplate.replace('__PERCENT__', String(Math.round((msrp - price) * 100 / msrp))) : '';
    }
    return available;
  }
  function cartRequest(method, data) {
    return new Promise(function (resolve, reject) {
      window.liquidAjaxCart[method](data, { lastCallback: function (state) {
        if (state.responseData && state.responseData.ok) resolve(state.responseData.body);
        else reject(new Error(window.gbBundleText.failed));
      } });
    });
  }
  async function add(source, id, handle, variants) {
    var container = source.closest('[data-gb-bundle-card], [data-gb-bundle-form]');
    var page = source.closest('[data-gb-page]');
    if (!container || source.dataset.gbBusy === 'true') return;
    var error = container.querySelector('[data-gb-error]');
    if (!inWindow(container) || (page && !refreshPage(page))) {
      if (error) error.textContent = window.gbBundleText.unavailable;
      return;
    }
    source.dataset.gbBusy = 'true'; source.disabled = true; source.setAttribute('aria-busy', 'true');
    if (error) error.textContent = '';
    var data = { items: [{ id: id, quantity: 1, properties: { _gb_bundle: handle, _gb_bundle_variants: variants } }] };
    try {
      if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === 'function') {
        await cartRequest('add', data);
      } else {
        var response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
        if (!response.ok) throw new Error(window.gbBundleText.failed);
        if (!(window.liquidAjaxCart && typeof window.liquidAjaxCart.update === 'function')) {
          window.location.assign(root + 'cart');
          return;
        }
        await cartRequest('update', {});
      }
      document.body.classList.add('js-show-ajax-cart');
    } catch (failure) {
      if (error) error.textContent = window.gbBundleText.failed;
    } finally {
      source.dataset.gbBusy = 'false'; source.disabled = !inWindow(container); source.setAttribute('aria-busy', 'false');
      if (page) refreshPage(page);
    }
  }
  function mountGalleries(scope) {
    if (!(window.GibbonProductGallery && window.jQuery)) return;
    scope.querySelectorAll('[data-gb-gallery]').forEach(function (gallery) { window.GibbonProductGallery.mount(window.jQuery(gallery)); });
  }
  function init(scope) {
    scope.querySelectorAll('[data-gb-page]').forEach(refreshPage);
    mountGalleries(scope);
  }
  document.addEventListener('change', function (event) { var page = event.target.closest('[data-gb-page]'); if (page) refreshPage(page); });
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-gb-bundle-form]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var page = form.closest('[data-gb-page]');
    if (!refreshPage(page)) return;
    add(form.querySelector('button[type="submit"]'), form.elements.id.value, form.elements['properties[_gb_bundle]'].value, form.elements['properties[_gb_bundle_variants]'].value);
  }, true);
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-gb-add]');
    if (!button) return;
    event.preventDefault();
    add(button, button.dataset.gbId, button.dataset.gbHandle, button.dataset.gbVariants);
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  window.addEventListener('resize', function () { mountGalleries(document); });
  // jQuery 3.6 + Slick load deferred at the end of the bundle section, after this script's first init.
  window.addEventListener('load', function () { mountGalleries(document); });
  function checkDates() {
    document.querySelectorAll('[data-gb-bundle-card]').forEach(function (card) { if (!inWindow(card)) card.hidden = true; });
    document.querySelectorAll('[data-gb-page]').forEach(refreshPage);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); checkDates(); });
  else { init(document); checkDates(); }
  window.setInterval(checkDates, 15000);
})();
